import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { PAYMENT_PREFIX_PATH } from 'configs/AppConfig'

export const PaymentViews = () => {
  return (
    <Suspense fallback={<Loading cover="page"/>}>
      <Switch>
        <Route path={`${PAYMENT_PREFIX_PATH}/subcription-plan`} component={lazy(() => import(`../payment-views/subscriptionPlans`))} />
        <Route path={`${PAYMENT_PREFIX_PATH}/register`} component={lazy(() => import(`../payment-views/paymentRegister`))} />
        <Route path={`${PAYMENT_PREFIX_PATH}/register-confirm`} component={lazy(() => import(`../payment-views/registerConfirm`))} />
        <Route path={`${PAYMENT_PREFIX_PATH}/summery`} component={lazy(() => import(`../payment-views/paymentReview`))} />
        <Route path={`${PAYMENT_PREFIX_PATH}/landing`} component={lazy(() => import(`../payment-views/completeLanding`))} />
        <Route path={`${PAYMENT_PREFIX_PATH}/error`} component={lazy(() => import(`../payment-views/errorPage`))} />
      </Switch>
    </Suspense>
  )
}

export default PaymentViews;

